import { misc, util } from "@/common/theme";
import BorderedIcon from "@/components/BorderedIcon";
import { ScrollingText } from "@/components/ScrollingText";
import { SectionTitle } from "@/components/SectionTitle";
import CustomSplitText from "@/mono/components/CustomSplitText";
import styled from "styled-components";
import { SmallTextSplit } from "./WhatWeDoHeader";
import { setTypography } from "@/mono/lib/styles/mixins";
import { mediaMobile } from "@/mono/lib/responsive";
import SplitText from "mono/components/SplitText";

export default function WhatWeDoExpertises() {
  return (
    <>
      <SectionTitle>Our expertises</SectionTitle>

      <Wrapper>
        <div className="expertise-left">
          <ScrollingText>Wij zorgen dat merken gezien worden.</ScrollingText>
        </div>
        <div className="expertise-right">
          <div>
            <SplitText tag="p" animateOnScroll>
              Opvallen in een wereld waar iedereen aandacht wil hebben? Dit is
              de vraag waar wij elke dag de wekker voor zetten. Nine gaat altijd
              voor spraakmakend, buitengewoon & zoekt de randen op, met zoveel
              mogelijke impact voor je merk creëren als einddoel.
            </SplitText>

            <BorderedIcon
              text="Contact"
              className="what-we-do__expertises-arrow"
            />
          </div>
        </div>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  width: 100%;

  ${util.inner}

  display: flex;

  .scrolling-text {
    max-width: 75%;
  }

  .expertise-left {
    width: ${misc.pageHalfWidth};
  }
  p {
    /* max-width: 70%; */
  }
  .expertise-right {
    width: calc(100% - ${misc.pageHalfWidth});
  }

  .what-we-do__expertises-arrow {
    margin-top: 100rem;
  }

  ${mediaMobile(`
    h3 {
      margin-bottom: 100rem;
    }

    flex-direction: column;
    .expertise-left {
      width: 100%;
    }

    .expertise-right {
      width: 100%;
    }

    .icon-container {
      margin-left: 300rem;
    }
  `)}
`;
